// ДЕМО-ПРОСМЁТ ПЕРВОЙ КАРТОЧКИ (B5-7). Борд `Deck v8`: `.row.demo` (`:112–116`, разметка `:474–484`)
// и `.chip.fresh` (`:128–129`, разметка `:487`).
//
// ⭐ УЗЛА ДВА, ПРАВИЛО ОДНО — И ЭТО ГЛАВНОЕ ОБ ЭТОМ ФАЙЛЕ. У борда предикат ползунков (`:476`
// `demo = S.i===0 && S.demo`) и предикат чипов (`:487` `fresh = S.i===0 && S.demo`) совпадают
// ПОБАЙТНО. Значит дом у решения один; разведи их по двум местам — и первая же правка развела бы
// призрачный ползунок с проявлением чипов, которые на борде показываются одним событием.
//
// ⚠️ ФЛАГ БОРДА `S.demo` ЖИВЁТ ДВУМЯ ПРАВИЛАМИ, И ОБА ПЕРЕНЕСЕНЫ:
//   · ставится `true` ТОЛЬКО полным сбросом сессии (`:419`, в одной строке с `S.i=0`);
//   · самогасится таймером 4200 мс после отрисовки первой карточки (`:517`).
// Отсюда ответ на все три вопроса скоупа тикета: только первая карточка · один раз за сессию ·
// при возврате НЕ повторяется.
//
// ⭐ ПАМЯТЬ — ТОКЕН В `revealsPlayed`, А НЕ НОВОЕ ПОЛЕ КОНВЕРТА, по образцу памяти стены
// (`s903.d2`). Скоуп у них один и тот же: сброс на `start over`, перезагрузку вкладки переживает.
// Своё поле означало бы новую версию схемы ради булева флага, у которого уже есть дом.
//
// ⚠️ И ЭТО РОВНО ТО, ЧЕГО У БОРДА НЕТ И НЕ МОГЛО БЫТЬ: у него нет сохранения вовсе, поэтому
// «при возврате не повторяется» он держит таймером в памяти вкладки. У нас возврат бывает ЧЕРЕЗ
// перезагрузку (тихий сейв, `s893`), и таймер такого возврата не пережил бы — человек, вернувшийся
// на устройство, увидел бы демо второй раз. Токен закрывает обе формы возврата одним утверждением.
//
// ⛔ `.demolab` НЕ ПОРТИРОВАН. Борд объявляет правило `:117`, но класса в разметке нет ни разу
// (`grep -c demolab` = 1 — само объявление). Это мёртвое правило на стороне CD, зеркало находки
// `.amb` из B5-6, перевёрнутое. Подпись демо-ряда придумывать нельзя — это копи; отсутствие
// названо отрицательным утверждением в парити, как `.card.in`.

/** Токен памяти демо в `revealsPlayed`. Форма адресоподобная, как у стены (`s3/wall`). */
export const DEMO_TOKEN = 's3/demo';

/**
 * Длительность жизни флага, мс (борд `:517`).
 *
 * ⚠️ ЭТО НЕ ДЛИТЕЛЬНОСТЬ АНИМАЦИИ, а окно, после которого узлы уходят из разметки. Сама волна
 * короче: 1.75 с цикла плюс задержка последней дорожки 360 мс (`:113–114`, `--dl`). Запас в борде
 * назначен так же — одним числом на оба узла, не суммой.
 */
export const DEMO_MS = 4200;

/** Цели призрачных ползунков по слоям, % (борд `:474`). Семь чисел, порядок = `LAYERS`. */
export const DEMO_TO = [97, 24, 68, 3, 86, 14, 60];

/** Шаг каскада между дорожками, мс (борд `:479` — `--dl:${li*60}ms`). */
export const DEMO_STEP_MS = 60;

/** Сыграно ли демо в этой сессии. */
export function demoPlayed(revealsPlayed) {
  return Array.isArray(revealsPlayed) && revealsPlayed.includes(DEMO_TOKEN);
}

/**
 * Записать демо в сыгранные. Возвращает ПРЕЖНИЙ массив, если токен уже там, — держатель стейта
 * сравнивает по ссылке и лишней записи в хранилище не делает (как `rememberWall`).
 */
export function rememberDemo(revealsPlayed) {
  const played = Array.isArray(revealsPlayed) ? revealsPlayed : [];
  return played.includes(DEMO_TOKEN) ? played : [...played, DEMO_TOKEN];
}

/**
 * Четыре переменные ряда (борд `:478–479`): цель призрака, левый край и ширина призрачного бара,
 * задержка каскада.
 *
 * ⚠️ СТАВЯТСЯ ВСЕГДА, А НЕ ТОЛЬКО ПОД ДЕМО, И ЭТО БАЙТ БОРДА. У него `style` ряда несёт их на
 * каждой карточке (`:479`), независимо от `demo`; развилка «ставить только в демо» завела бы
 * разметку, которой у борда нет, ради экономии четырёх переменных, ничего не красящих без класса.
 */
export function demoVars(li) {
  const to = DEMO_TO[li];
  if (to === undefined) return {};
  return {
    '--to': `${to}%`,
    '--bl': `${Math.min(50, to)}%`,
    '--bw': `${Math.abs(to - 50)}%`,
    '--dl': `${li * DEMO_STEP_MS}ms`,
  };
}
